import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import {Select, Button, InputLabel, FormControl, TextField, OutlinedInput }from '@material-ui/core';
import { Check, LockOpen, Lock}from '@material-ui/icons';

import WhsPoDetailsTable from '../whsPoDetailsTable/WhsPoDetailsTable';
import WhsDoDetailsTable from '../whsDoDetailsTable/WhsDoDetailsTable';
import CommonYesNoContainer from '../../common/commonYesNo/CommonYesNoContainer';
import CommonTruckerLockedContainer from '../../common/trucker/truckerLocked/CommonTruckerLockedContainer';

import GhaDock from '../../../models/GhaDock';
import OrderWhsDetails from '../../../models/OrderWhsDetails';
import { OrderLockStatusType } from '../../../models/OrderLockStatusType.enum';

import whsOrderDetailsStyles from './whsOrderDetails.module.css';
import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    textField: {
      color: 'var(--primaryblue)',
      width:'100%',
      padding: '6px 14px',
      boxSizing: 'border-box'
    },
    textFieldInput: {
      padding: '11px 14px',
      width: 190,
      color: 'var(--primaryblue)'
    },
    textFieldBlue: {
      transform: 'translate(14px, 12px) scale(1)',
      color: 'var(--primaryblue)'
    },
    textFieldGrey: {
      transform: 'translate(14px, 12px) scale(1)',
      color: 'rgb(0,0,0,0.26)'
    },
    grey: {
      color: 'grey'
    },
    blue: {
      color: 'var(--primaryblue)'
    },
    green: {
      color: 'rgb(66, 183, 70)'
    },
    checkGreen: {
      color: 'green',
      marginLeft: '10px',
      marginTop: '3px',
      fontSize: '30px',
      cursor: 'pointer'
    },
    checkDisabled: {
      color: 'gray',
      marginLeft: '10px',
      marginTop: '3px',
      fontSize: '30px',
      cursor: 'default'
    },
    input: { 
      marginBottom: 0,
      marginTop: 0,
      '&>div': {
      height: '27px',
      width: '106px',
      marginLeft: '10px'
      }
    },
    formControl: {
      width:'80%'
    },
    button: {
      marginTop: '20px',
      marginRight: '10px',
      minWidth: '155px',
      color: '#fff !important',
    },
    cursor: {
      cursor: 'pointer',
    },
    outlinedInput: {
      '& select':{
        padding: '8px 14px !important',
      }
    }
  });

interface WhsOrderDetailsProps {
  type: string;
  classes: any;
  order: OrderWhsDetails;
  selectedDock: number;
  docks: Array<GhaDock>;
  handleChangeDriverId: (event: React.ChangeEvent<HTMLInputElement>) => void;
  driverIdManual: string;
  updateDriverId: () => void;
  doLockPickupOrder: () => void;
  selectedAwb: string;
  handleChangeAwb: (awbNumber: string, version: number) => void;
  handleDockChange: (event: any) => void;
  handleSetTruckOnDock: () => void;
  gotoAwbPage: (type: 'report' | 'weight') => void;
  gotoOrderNote: () => void;
  gotoDriverSignature: () => void;
  gotoPosPage: () => void;
  sealLockVerify: Function;
  handleOpenPoD: (awbCode: string, awbNumber: string, version: number) => void;
  driverIdTypeManual: string;
  openDialog: (type: string, awbCode: string, awbNumber: string, version: number) => void;
  history: any;
  uploadFile: (event: any, awbCode: string, awbNumber: string, version: number) => void;
};

const whsOrderDetails = (props: WhsOrderDetailsProps) => {

  const { classes, order } = props;
  const disabled: boolean = order.status === 'delivered' || order.lock_status !== OrderLockStatusType.LOCKED ;
  const sealLockVerifyDisabled: boolean = props.type === 'do' && order.seal_lock_verified === false ? true : false;
  const dimsDisabled: boolean = (props.type === 'do' || props.type === 'rfs') ? false : true;
  const poDock: number = order.id_dock === null ? -1 : order.id_dock;
  const driverContact: string = order.driver_contact === null || order.driver_contact.includes('@') ? '' : order.driver_contact;
  const deliveryCompanyContact: string = order.delivery_company_phone === null ? '' : order.delivery_company_phone;
  let color: string = classes.grey;

  if (order.lock_status === OrderLockStatusType.LOCKED) {
    color = classes.blue;
  }

  const dockOptions: Array<JSX.Element> = props.docks.map((dock: GhaDock, index: number) => (
    <option key={ index } value={ dock.id }>{ dock.name }</option>
  ));
  return (
    <div className={ whsOrderDetailsStyles.wrapper }>

      <div className={ whsOrderDetailsStyles.header }>
        <span className={ whsOrderDetailsStyles.poNumber }>{ (props.type === 'rfs')? order.rfs_number : order.number }</span>
      </div>

      <div className={ whsOrderDetailsStyles.deliveryCompanyWrapper }>

        <div className={ whsOrderDetailsStyles.driverWrapper } >
          <div className={ whsOrderDetailsStyles.driverName } >
            <span  className={ whsOrderDetailsStyles.driverTitle }>Trucking Company</span>
            <span  className={ whsOrderDetailsStyles.driverData }>{ order.delivery_company_name }</span>
          </div>
          <div className={ whsOrderDetailsStyles.driverContact } >{ driverContact === '' ? deliveryCompanyContact : '' }</div>
        </div>

        <div className={ whsOrderDetailsStyles.driverWrapper } >
          <div className={ whsOrderDetailsStyles.driverName } >
            <span  className={ whsOrderDetailsStyles.driverTitle }>Driver</span>
            <span  className={ whsOrderDetailsStyles.driverData }>{ order.driver_name }</span>
          </div> 
          <div className={ whsOrderDetailsStyles.driverContact } >{ deliveryCompanyContact === '' ? driverContact : '' }</div>
        </div>

        { order.driver_id_type && 
        <div className={ whsOrderDetailsStyles.driverWrapper } >
          <div className={ whsOrderDetailsStyles.driverName }> 
            <span className={ whsOrderDetailsStyles.driverTitle }>Driver's ID Type</span> 
            <span className={ whsOrderDetailsStyles.driverData }>{ order.driver_id_type }</span> 
          </div>
        </div>
       }
  
          { (!order.driver_id && order.order_type === 'po') &&
            <div >
              <TextField
                  id="driverIdType"
                  variant="outlined"
                  label={ `Driver's ID Type` }
                  value={ props.driverIdTypeManual }
                  onChange={ props.handleChangeDriverId }
                  InputProps={{ 
                    className: classes.textField,
                    classes: { input: classes.textFieldInput }
                  }}
                  InputLabelProps={{ className: props.driverIdTypeManual ? classes.textFieldBlue : classes.textFieldGrey }}
              />
                <TextField
                  id="driverId"
                  variant="outlined"
                  label={ `Driver's ID` }
                  value={ props.driverIdManual }
                  onChange={ props.handleChangeDriverId }
                  InputProps={{ 
                    className: classes.textField,
                    classes: { input: classes.textFieldInput }
                  }}
                  InputLabelProps={{ className: props.driverIdManual ? classes.textFieldBlue : classes.textFieldGrey }}
              />
              <Check
                className={ props.driverIdManual.trim().length > 0 ? classes.checkGreen : classes.checkDisabled }
                onClick={ props.driverIdManual.trim().length > 0 ? props.updateDriverId : () => null }
              />
            </div>
          }

        { order.driver_id && 
        <div className={ whsOrderDetailsStyles.driverWrapper } >
          <div className={ whsOrderDetailsStyles.driverName } >
          <span  className={ whsOrderDetailsStyles.driverTitle }>Driver's ID</span>
          <span  className={ whsOrderDetailsStyles.driverData }>{ order.driver_id.replace(/.(?=.{4,}$)/g, '#') }</span>
          </div> 
        </div>
        }

      </div>
      { (props.type === 'do' || props.type === 'rfs') && 
        <Fragment>
          <div className={ `${ commonStyles.wrapper } ${ whsOrderDetailsStyles.seallockContainer }` } >
            <h3 className={ commonStyles.header }> Seal/Lock </h3>
            <div className={ whsOrderDetailsStyles.commonTruckerLocked }>
              <CommonTruckerLockedContainer
                dropOffOrder={ order }
                view={ 'whsMobile' }
                editable={ false }
              />
            </div>
            <div className={ whsOrderDetailsStyles.commonYesNo }>
              <label className={ commonStyles.inputLabel }>Verify Seal/Lock</label>
              <CommonYesNoContainer 
                label={ '' }
                name={ 'sealLockVerify' }
                value={ order.seal_lock_verified } 
                setValue={ props.sealLockVerify } 
                editable={ !disabled }
                disabled={ order.allowed_ops.update_dispatch_driver_details }
              />
            </div>
            <div className={ whsOrderDetailsStyles.textareaRemarks }>
              <TextField
                placeholder="-- Enter remarks"
                multiline
                rows="1"
                rowsMax="2"
                margin="normal"
                variant="outlined"
                InputProps={{ 
                  className: classes.textField,
                }}
                fullWidth
              />
            </div>
          </div>
        </Fragment>
      }
      <div className={ whsOrderDetailsStyles.workedOn }>
        <span className={ whsOrderDetailsStyles.workedOnByTitle } > 
          <div className={ whsOrderDetailsStyles.wobDriverName } >
            <span  className={ whsOrderDetailsStyles.wobDriverTitle }>Worked on by :</span>
            <span  className={ whsOrderDetailsStyles.wobDriverData }>{ order.gha_wh_user_name }</span>
          </div>
          <span>
            { order.lock_status === OrderLockStatusType.UNLOCKED
              ? <LockOpen fontSize='large' onClick={ props.doLockPickupOrder } className={ classes.green } />
              : <Lock fontSize='large' onClick={ props.doLockPickupOrder } className={ color } />
            }
          </span>
        </span>
      </div>
      { (props.type === 'po' || props.type === 'go') &&
        <div className={ `${ commonStyles.wrapper } ${ whsOrderDetailsStyles.tableWrapper }` }>
          <h3 className={ commonStyles.header }> Orders </h3>
          <WhsPoDetailsTable 
            pickupOrder={ order }
            selectedAwb={ props.selectedAwb } 
            handleChangeAwb={ props.handleChangeAwb } 
            handleOpenPoD={ props.handleOpenPoD }
            openDialog={ props.openDialog } 
            uploadFile={ props.uploadFile }
          />
        </div>
      }
      { (props.type === 'do' || props.type === 'rfs') &&
        <div className={ `${ commonStyles.wrapper } ${ whsOrderDetailsStyles.tableWrapper }` }>
          <h3 className={ commonStyles.header }> Orders </h3>
          <WhsDoDetailsTable 
            dropOffOrder={ order }
            selectedAwb={ props.selectedAwb }
            openDialog={ props.openDialog } 
            handleChangeAwb={ props.handleChangeAwb }
            handleOpenPoD={ props.handleOpenPoD } 
            history={ props.history } 
            uploadFile={ props.uploadFile }
          />
        </div>
      }

      <div className={ `${ commonStyles.wrapper }` }>
        <h3 className={ commonStyles.header }> Dock Number </h3>
        <div className={ `${ whsOrderDetailsStyles.dockSelect  } ${ commonStyles.inputLabelWrapper }` } >
          <label className={ commonStyles.inputLabel }>Select Dock Number</label>
          <FormControl className={ classes.formControl } variant="outlined">
            <Select
              native
              disabled={ disabled || !order.allowed_ops.set_dock }
              onChange={ props.handleDockChange } 
              value={ poDock }
              input={ <OutlinedInput labelWidth={ 0 } /> }
              inputProps={{
                classes:{ root: classes.outlinedInput }
              }}
            >
              <option value={ -1 } />
              { dockOptions }
            </Select>
          </FormControl>
        </div>
      </div>
            
      <div className={ whsOrderDetailsStyles.buttonContainer }>
        { props.type !== 'rfs' &&      
          <Button
            disabled={ props.selectedAwb === '' || sealLockVerifyDisabled }
            color="primary" 
            variant="contained"
            onClick={ () => { props.gotoAwbPage('report') } }
            className={ classes.button } 
          > 
          { props.order.allowed_ops.update_exception_and_notes ? 'Awb Report Exception': 'Awb Exception'}
          </Button>
        }     
        { props.type === 'do' &&       
          <Button
            disabled={ props.selectedAwb === '' || dimsDisabled }
            color="primary" 
            variant="contained"
            className={ classes.button }
            onClick={ () => { props.gotoAwbPage('weight') } }
          >Dims & Weight
          </Button>
        }
        <Button
          color="primary" 
          variant="contained"
          onClick={ props.gotoOrderNote }
          className={ classes.button } 
        >
        { props.order.allowed_ops.update_exception_and_notes ? 'Add Order Notes ' : 'Order Notes' }
        </Button>
        <Button 
          disabled={ sealLockVerifyDisabled }
          color="primary" 
          variant="contained"
          onClick={ props.gotoDriverSignature }
          className={ classes.button } 
        >Driver signature
        </Button>
        <Button 
          color="primary" 
          variant="contained"
          onClick={ props.gotoPosPage }
          className={ classes.button } 
        >Exit
        </Button>
      </div>
      
    </div>
  );
};

export default withStyles(styles)(whsOrderDetails);